export enum ColumnsEnum {
  CREATED_DATE = 'created_date',
  NAME = 'name',
  OPERATION_ID = 'operation_id',
  VERTICAL = 'vertical',
  ID = 'id',
  SITE_ID = 'site_id',
  ACTIONS = 'actions',
}
